import { UIText3 } from '@cian/ui-kit';
import * as React from 'react';

// @ts-expect-error TODO: исправить импорт картинок
import phoneImg from './assets/phone.svg';
import * as styles from './styles.css';

type TUserCardCallButton = {
  phone: string;
  onClick(): void;
};

export const UserCardCallButton: React.FC<TUserCardCallButton> = ({ phone, onClick }) => {
  return (
    <a
      href={phone}
      target="_blank"
      className={styles['call_button']}
      data-testid="UserCardCallButton"
      onClick={onClick}
    >
      <img src={phoneImg} width={24} height={24} />
      <UIText3 color="text-main-default">Позвонить</UIText3>
    </a>
  );
};
